module.exports = __webpack_public_path__ + "img/rusted-poster.666fb593.png";